import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";

import { MatSelectCountryModule } from "@angular-material-extensions/select-country";
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { provideClientHydration } from "@angular/platform-browser";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideEffects } from "@ngrx/effects";
import { provideState, provideStore } from "@ngrx/store";
import { provideStoreDevtools } from "@ngrx/store-devtools";
import { routes } from "./app.routes";
import { HttpLoaderInterceptor } from "./core/interceptors/http-loader.interceptor";
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { authFeatureKey, authReducer } from "./features/login/store/reducers";
import * as authEffects from "./features/login/store/effects";
import * as registrationEffects from "./features/registration/store/effects";
import {
  registrationFeatureKey,
  registrationReducer,
} from "./features/registration/store/reducer";
import { RECAPTCHA_V3_SITE_KEY } from "ng-recaptcha";
import { environment } from "../environments/environment";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideStore(),
    provideState(authFeatureKey, authReducer),
    provideState(registrationFeatureKey, registrationReducer),
    provideEffects(authEffects),
    provideEffects(registrationEffects),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaKey,
    },
    { provide: MAT_DATE_LOCALE, useValue: "en-ZA" },

    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: "YYYY-MM-DD",
        },
        display: {
          dateInput: "YYYY-MM-DD",
          monthYearLabel: "YYYY MMM",
          dateA11yLabel: "LL",
          monthYearA11yLabel: "YYYY MMM",
        },
      },
    },
    importProvidersFrom(MatSelectCountryModule.forRoot("en")),
    provideStoreDevtools({
      maxAge: 25,
      logOnly: isDevMode(),
      autoPause: true,
      trace: false,
      traceLimit: 75,
      connectInZone: true,
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpLoaderInterceptor,
      multi: true,
    },
  ],
};
